export interface CalendarEvent {
  id: number
  title: string
  /** Day of the month shown in the calendar (February). */
  day: number
  time: string
  date: string
  duration: string
  type: 'video' | 'phone'
  location: string
  meetingLink: string
  organizer: string
  attendees: string[]
  description: string
  aiManaged: boolean
  /** The call Vexu booked this meeting on. */
  originatingCall?: { id: number; label: string; caller: string }
  accent: string
  accentText: string
}

export const CALENDAR_EVENTS: CalendarEvent[] = [
  {
    id: 1,
    title: 'Product Sync',
    day: 24,
    time: '10:00 AM – 11:00 AM',
    date: 'Tuesday, February 24',
    duration: '1 hour',
    type: 'video',
    location: 'Google Meet',
    meetingLink: 'meet.google.com/abc-defg-hij',
    organizer: 'Sarah Miller',
    attendees: ['Alex Founder', 'Sarah Miller', 'Mike Ross'],
    description:
      'Weekly product alignment to review the roadmap, discuss blockers, and prioritize the upcoming sprint.',
    aiManaged: false,
    accent: 'bg-blue-500',
    accentText: 'text-blue-500',
  },
  {
    id: 2,
    title: 'Client Discovery Call',
    day: 24,
    time: '1:30 PM – 2:15 PM',
    date: 'Tuesday, February 24',
    duration: '45 minutes',
    type: 'phone',
    location: '+1 (555) 012-3456',
    meetingLink: '',
    organizer: 'Vexu AI Agent',
    attendees: ['Alex Founder', 'Jordan Lee (Client)'],
    description:
      'Initial discovery call booked automatically by your AI agent. Understand the client needs and qualify the opportunity.',
    aiManaged: true,
    originatingCall: { id: 2, label: 'Mike Ross · 11:15 AM', caller: 'Mike Ross' },
    accent: 'bg-vexu',
    accentText: 'text-vexu',
  },
  {
    id: 3,
    title: 'Design Review',
    day: 24,
    time: '3:00 PM – 4:00 PM',
    date: 'Tuesday, February 24',
    duration: '1 hour',
    type: 'video',
    location: 'Zoom',
    meetingLink: 'zoom.us/j/9876543210',
    organizer: 'Emily Chen',
    attendees: ['Design Team', 'Alex Founder', 'Emily Chen'],
    description:
      'Review the latest mockups for the onboarding flow and finalize the visual direction before development.',
    aiManaged: false,
    accent: 'bg-purple-500',
    accentText: 'text-purple-500',
  },
  {
    id: 4,
    title: 'Investor Update',
    day: 24,
    time: '5:00 PM – 5:30 PM',
    date: 'Tuesday, February 24',
    duration: '30 minutes',
    type: 'video',
    location: 'Google Meet',
    meetingLink: 'meet.google.com/xyz-uvwx-rst',
    organizer: 'Vexu AI Agent',
    attendees: ['Alex Founder', 'Board Members'],
    description: 'Monthly investor sync covering key metrics, growth highlights, and the next funding milestone.',
    aiManaged: true,
    originatingCall: { id: 4, label: 'Design Team · Monday', caller: 'Design Team' },
    accent: 'bg-vexu',
    accentText: 'text-vexu',
  },
  {
    id: 5,
    title: 'Supplier Contract Review',
    day: 26,
    time: '11:00 AM – 11:30 AM',
    date: 'Thursday, February 26',
    duration: '30 minutes',
    type: 'video',
    location: 'Google Meet',
    meetingLink: 'meet.google.com/omk-dxbs-ctr',
    organizer: 'Vexu AI Agent',
    attendees: ['Alex Founder', 'Omar Khalil'],
    description: 'Review the Dubai supplier contract terms Omar raised on his call, and agree next steps.',
    aiManaged: true,
    originatingCall: { id: 14, label: 'Omar Khalil · 12:40 PM', caller: 'Omar Khalil' },
    accent: 'bg-vexu',
    accentText: 'text-vexu',
  },
  {
    id: 6,
    title: 'Follow-up Consultation',
    day: 27,
    time: '2:00 PM – 2:45 PM',
    date: 'Friday, February 27',
    duration: '45 minutes',
    type: 'phone',
    location: '+1 (555) 014-2290',
    meetingLink: '',
    organizer: 'Vexu AI Agent',
    attendees: ['Alex Founder', 'Sarah Miller'],
    description: 'Follow-up Sarah requested on her call to go through the revised proposal together.',
    aiManaged: true,
    originatingCall: { id: 6, label: 'Sarah Miller · Yesterday', caller: 'Sarah Miller' },
    accent: 'bg-vexu',
    accentText: 'text-vexu',
  },
]

/** Meetings Vexu booked from calls, in date order. */
export const AI_BOOKINGS = CALENDAR_EVENTS.filter((e) => e.aiManaged)
